// ============================================================================
// papelClientes.js — quem recebe a LISTA de clientes no aparelho (espelho)
// ============================================================================
// 16/10/2026 (segurança: "RLS do servidor"). Espelho no navegador da regra R2
// de api/_lib/db-papeis.js. O /api/db decide de verdade; este espelho só
// decide O QUE O DataContext PEDE, para que o celular do barbeiro não baixe a
// base inteira de clientes (≈21 mil, com CPF/telefone/nascimento), as comandas
// (nome e telefone do cliente) nem a agenda — nenhuma tela que o barbeiro
// abre usa essas listas (inventário em tests/db-papeis.test.mjs, que também
// confere que este espelho e o servidor decidem igual em todos os cargos).
//
// Pode ver: conta 'admin' (gestão, qualquer cargo) e os cargos do balcão
// (Recepcionista, Gerente) com cadastro ativo — inclusive a recepcionista
// legada com conta 'professional'. Demais (Barbeiro, Manicure…) → lista vazia,
// sem erro.
// ============================================================================

export const CARGOS_LISTA_CLIENTES = Object.freeze(['Recepcionista', 'Gerente']);

export function podeVerListaClientes({ role, cargo, ativo = true } = {}) {
  if (role === 'admin') return true;
  return !!ativo && CARGOS_LISTA_CLIENTES.includes(cargo);
}

// Estado para o DataContext:
//   'aguardando' — sessão ainda resolvendo, ou conta com cadastro ligado e
//                  cadastro ainda não carregado (aparelho novo): não pede nada
//                  e não mexe no que já está na tela;
//   'nenhum'     — sem sessão (tela de login): não pede (o servidor daria 401);
//   'sim'        — pede clientes, agenda e comandas;
//   'nao'        — não pede; listas vazias.
export function escopoListaClientes({ user, authLoading = false, professionals } = {}) {
  if (authLoading) return 'aguardando';
  if (!user) return 'nenhum';
  if (user.role === 'admin') return 'sim';
  const lista = Array.isArray(professionals) ? professionals : [];
  if (user.professionalId && lista.length === 0) return 'aguardando';
  const prof = user.professionalId ? lista.find(p => p?.id === user.professionalId) : null;
  const ativo = !!prof && prof.active !== false && !prof.deletedAt;
  return podeVerListaClientes({ role: user.role, cargo: prof?.role || null, ativo }) ? 'sim' : 'nao';
}
